<template>
  <div class="container-fluid">
    <div class="row justify-content-center align-items-center">
      <div class="col-3">
        <div class="logo"></div>

        <div class="logo-title">
          <h2>Quizify</h2>
        </div>

        <div class="sub-title" :class="{ errorSubtitle: isError }">
          <h3>{{ subTitle }}</h3>
        </div>

        <div class="login-inputs mt-3">
          <input v-model="teacherData.login" type="text" placeholder="ID" required>
        </div>

        <div class="login-inputs mt-3">
          <input v-model="teacherData.password" type="password" placeholder="Password" required>
        </div>

        <div class="login-submit mt-3">
          <button @click.prevent.stop="login()">{{message}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      message: "Continue",
      subTitle: "Login to continue",
      isError: false,
      teacherData: {
        login: "",
        password: ""
      }
    };
  },
  methods: {
    login() {
      this.message = "Logging in...";
      this.isError = false;
      this.subTitle = "Login to continue";

      axios
        .post(`${apiUrl}/auth/teacher`, {
          teacherID: this.teacherData.login,
          password: this.teacherData.password
        })
        .then(res => {
          if (res.data.status) {
            this.message = "🎉";
            sessionStorage.setItem("userToken", res.data.token);
            sessionStorage.setItem(
              "teacherData",
              JSON.stringify(res.data.teacher)
            );
            location.reload();
          } else {
            this.subTitle = res.data.message;
            this.isError = true;
            this.message = "Continue";
          }
        })
        .catch(err => {
          this.message = err.response.data.message;
        });
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../assets/scss/variables";

.container-fluid,
.row {
  height: 100vh;
}

.container-fluid {
  background-image: url("../assets/images/bg_web.png");
  background-position: center 56vh;
  background-repeat: no-repeat;
}

.logo {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  background-image: url("../assets/images/Logo_180.png");
  background-position: center center;
  background-size: 100% 100%;
  margin: 0 auto;
}

.logo-title h2 {
  color: $black;
  font-size: 2rem;
  font-weight: 900;
  text-align: center;
}

.sub-title h3 {
  color: #b5b6b9;
  font-weight: 100;
  font-size: 1.2rem;
  text-align: center;
}

.sub-title.errorSubtitle h3 {
  color: $red;
  font-weight: 400;
}

.login-inputs {
  input {
    padding: 0.4rem 0.9rem;
    width: 100%;
    color: $placeholderColor;
    background-color: $grey;
    border-radius: $borderRadius;
    border: none;
    outline: none;
  }

  input::placeholder {
    color: $placeholderColor;
  }
}

.login-submit {
  button {
    background-color: $blue;
    width: 100%;
    border: none;
    outline: none;
    color: white;
    padding: 0.4rem 0.9rem;
    border-radius: $borderRadius;
  }
}
</style>
